<template>
  <ButtonGroup>
    <FwbDropdown>
      <template #trigger>
        <BlueButton>Expo: {{ config_options.expo }} <DocsIconChevronDown /></BlueButton>
      </template>
      <FwbListGroup>
        <FwbListGroupItem @click="set_option({ expo: 'yes' })">Yes, I use Expo + EAS to build</FwbListGroupItem>
        <FwbListGroupItem @click="set_option({ expo: 'prebuild' })">
          Yes, I use Expo + CNG (prebuild)
        </FwbListGroupItem>
        <FwbListGroupItem @click="set_option({ expo: 'no' })"> No, I don't use Expo (or I ejected) </FwbListGroupItem>
      </FwbListGroup>
    </FwbDropdown>
  </ButtonGroup>
</template>

<script setup lang="ts">
import { FwbDropdown, FwbListGroup, FwbListGroupItem } from "flowbite-vue";

const config_options = useConfigOptions();

function set_option(option: Partial<ConfigOptions>) {
  config_options.value = { ...config_options.value, ...option };
}
</script>

<style scoped>
button {
  svg {
    @apply ml-1 mr-[-10px];
  }
}

li {
  @apply cursor-pointer;
}
</style>
